module.exports = __webpack_public_path__ + "static/media/campaigns.54a851d6.svg";